import {SellOrderStore} from './sell_order';

export class BuyOrderStore extends SellOrderStore {
    loadMoreLink = '/shop/marketplace/buy_orders';

    deleteLink = id => `/artifact_orders/${id}/destroy_buy_order`;
}
